import React from "react";
import { Chip, makeStyles, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: "100%",
  },
  label: {
    display: "block",
    fontSize: "0.85rem",
    fontWeight: 700,
    marginBottom: theme.spacing(0.75),
    color: theme.palette.text.primary,
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    padding: theme.spacing(1.25),
    borderRadius: 10,
    backgroundColor: theme.palette.action.hover,
    border: `1px solid ${theme.palette.divider}`,
  },
  chip: {
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: 8,
    height: 28,
  },
}));

const MessageVariablesPicker = ({
  onClick,
  disabled,
  showSchedulingVars = false,
  hideLabel = false,
}) => {
  const classes = useStyles();

  const handleClick = (e, value) => {
    e.preventDefault();
    if (disabled) return;
    onClick(value);
  };

  const msgVars = [
    {
      name: i18n.t("messageVariablesPicker.vars.contactFirstName"),
      value: "{{firstName}}",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.contactName"),
      value: "{{name}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.user"),
      value: "{{userName}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.greeting"),
      value: "{{ms}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.protocolNumber"),
      value: "{{protocol}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.date"),
      value: "{{date}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.hour"),
      value: "{{hour}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.ticket_id"),
      value: "{{ticket_id}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.queue"),
      value: "{{queue}} ",
    },
    {
      name: i18n.t("messageVariablesPicker.vars.connection"),
      value: "{{connection}} ",
    },
  ];

  if (showSchedulingVars) {
    msgVars.push({
      name: i18n.t("messageVariablesPicker.vars.scheduledDate"),
      value: "{{dataAgendamento}} ",
    });
  }

  return (
    <div className={classes.wrapper}>
      {!hideLabel && (
        <Typography component="span" className={classes.label}>
          {i18n.t("messageVariablesPicker.label")}
        </Typography>
      )}
      <div className={classes.root}>
        {msgVars.map((msgVar) => (
          <Chip
            key={msgVar.value}
            onMouseDown={(e) => handleClick(e, msgVar.value)}
            label={msgVar.name}
            size="small"
            className={classes.chip}
            color="primary"
            variant="outlined"
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default MessageVariablesPicker;
